import { Stack, Typography } from '@mui/material';
import { useFormik } from 'formik';
import * as yup from 'yup';
import Page from '../../../components/Page';
import Article from '../../../components/Article';
import CustomButton from '../../../components/CustomButton';
import ThemedTextField from '../../../components/ThemedTextField';
import { useTenant } from '../../../contexts/TenantContext';
import { Routes } from '../../../routes/RouteConstants';
import AuthLink from '../components/AuthLink';
import useAuthRequest from '../useAuthRequest';
import useAuthNextStep from '../useAuthNextStep';
import { emailRule } from '../validation';

const validationSchema = yup.object({
  email: emailRule,
});

// Asks for the address only; the code and the new password are typed on /verify-email. The answer
// is the same whether or not the address has an account, and no mail goes to one without (A13).
const ForgotPasswordLayout = () => {
  const { displayConfig } = useTenant();
  const passwordReset = useAuthRequest("password-reset");
  const goToNextStep = useAuthNextStep();

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: validationSchema,
    onSubmit: async ({ email }) => {
      const authResponse = await passwordReset.send({ email });
      goToNextStep(authResponse, { email: email.trim(), purpose: "PASSWORD_RESET" });
    },
  });

  return (
    <Page>
      <Article xsHorizontalPadding={2} title="Elfelejtett jelszó" titleVariant="h5">
        <Typography variant="body1" color={displayConfig?.color} mb={3} textAlign="center">
          Add meg az email címedet, és küldünk rá egy kódot, amellyel új jelszót állíthatsz be.
        </Typography>

        <form onSubmit={formik.handleSubmit} style={{ width: '100%' }} noValidate>
          <Stack spacing={3}>
            <ThemedTextField
              id="email"
              name="email"
              label="Email cím"
              type="email"
              autoComplete="email"
              value={formik.values.email}
              onChange={formik.handleChange}
              error={formik.touched.email && Boolean(formik.errors.email)}
              helperText={formik.touched.email && formik.errors.email}
            />
            <CustomButton text="Kód küldése" textTransform="none" type="submit" isLoading={passwordReset.loading} />
          </Stack>
        </form>

        <Typography variant="body2" color={displayConfig?.color} mt={3} textAlign="center">
          <AuthLink to={Routes.LOGIN}>Vissza a bejelentkezéshez</AuthLink>
        </Typography>
      </Article>
    </Page>
  );
};

export default ForgotPasswordLayout;
